import { handleDeleteConfirmation } from 'Utils/handleDelete';
import { fetchMainProgram, deleteMainProgram, replicateMainProgram } from 'Features/Learning/MainPrograms/Utils/MainProgramUtils';
import Swal from 'sweetalert2';

/* **************************************************** */
/* CRUD Main Program                                    */
/* **************************************************** */

export const fetchMainPrograms = (dispatch, filters, refetch) => {
	dispatch(fetchMainProgram(filters));
}

export const handleDeleteMainProgram = async (dispatch, id, setRefetch) => {
	handleDeleteConfirmation({
		dispatch,
		id,
		setRefetch,
		deleteAction: deleteMainProgram,
	});
}

export const handleEditMainProgram = async (dispatch, item, setField) => {
	const fieldsToUpdate = ['title', 'is_tryout_only', 'is_private', 'is_recommended', 'header_desc', 'content_desc'];

	fieldsToUpdate.forEach(field => {
		dispatch(setField({ field, value: item[field] }));
	});

	dispatch(setField({ field: 'id', value: item.id }));
	dispatch(setField({ field: 'isUpdate', value: true }));
	dispatch(setField({ field: 'membership', value: item.membership }));
	dispatch(setField({ field: 'category_id', value: item.category }));
	dispatch(setField({ field: 'image', value: '' }));
	dispatch(setField({ field: 'bannerLink', value: item.image }));
	dispatch(setField({ field: 'attachmentLink', value: item.attachment }));
	dispatch(setField({ field: 'order', value: item.order }));

	if (item.is_recommended == 1) {
		dispatch(setField({ field: 'title_recommended', value: item.title_recommended }));
		dispatch(setField({ field: 'description_recommended', value: item.description_recommended }));
	} else {
		dispatch(setField({ field: 'title_recommended', value: '' }));
		dispatch(setField({ field: 'description_recommended', value: "" }));
	}

	if (item.batch !== null) {
		dispatch(setField({ field: 'batch', value: item.batch }));
	} else {
		dispatch(setField({ field: 'batch', value: '' }));
	}

	if (item.video_promo !== null) {
		dispatch(setField({ field: 'video_promo', value: item.video_promo }));
	} else {
		dispatch(setField({ field: 'video_promo', value: '' }));
	}

	if (item.slug !== null) {
		dispatch(setField({ field: 'slug', value: item.slug }));
		dispatch(setField({ field: 'is_campus_event', value: 1 }));
		dispatch(setField({ field: 'old_slug', value: item.slug }));
	} else {
		dispatch(setField({ field: 'slug', value: '' }));
		dispatch(setField({ field: 'is_campus_event', value: 0 }));
	}

	if (item.point !== null && JSON.parse(item.point).length > 0) {
		dispatch(setField({ field: 'point', value: JSON.parse(item.point) }));
		dispatch(setField({ field: 'isPoint', value: true }));
	} else if (item.point === null || JSON.parse(item.point).length === 0) {
		dispatch(setField({ field: 'point', value: '' }));
		dispatch(setField({ field: 'isPoint', value: false }));
	}
}

export const handleGetDetailMainProgram = async (dispatch, item, setDetail) => {
	dispatch(setDetail(item));
}

export const handleReplicateMainProgram = async (dispatch, item, setRefetch) => {
	try {
		Swal.fire({
			title: 'Apakah anda yakin?',
			html: `Anda akan menduplikasi <strong>${item.title}</strong> ini!`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33'
		}).then(async (result) => {
			if (result.isConfirmed) {
				const response = await dispatch(replicateMainProgram(item.id));
				if (response.payload.status === 201) {
					setRefetch(prevRefetch => !prevRefetch);
					Swal.fire(
						'Berhasil!',
						'Data telah diduplikasi.',
						'success'
					)
				} else {
					Swal.fire(
						'Gagal!',
						'Data gagal diduplikasi.',
						'error'
					)
				}
			}
		})
	} catch (error) {
		console.error("Duplicate error:", error);
	}
}

/* **************************************************** */
/* Pagination                                           */
/* **************************************************** */

export const handleBackPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
	if (pagination.current_page > 1) {
		dispatch(setFilters({
			...filters,
			page: pagination.current_page - 1
		}));
		setRefetch(prevRefetch => !prevRefetch);
	}
}

export const handleNextPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
	if (pagination.current_page < pagination.last_page) {
		dispatch(setFilters({
			...filters,
			page: pagination.current_page + 1
		}));
		setRefetch(prevRefetch => !prevRefetch);
	}
}

export const handleClickPagination = (page, filters, dispatch, setFilters, setRefetch) => {
	dispatch(setFilters({
		...filters,
		page: page
	}));
	setRefetch(prevRefetch => !prevRefetch);
}